export const XLogo = () => (
  <a
    href="https://twitter.com/prenuvo"
    aria-label="click this link to go to Prenuvo's x page"
    aria-current="page"
    className="transition ease-in-out hover:opacity-70"
    rel="noopener noreferrer"
  >
    <svg
      aria-label="x social media link to Prenuvo's page"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <path
        d="M17.1761 4H19.9362L13.9061 10.7774L21 20H15.4456L11.0951 14.4066L6.11723 20H3.35544L9.80517 12.7508L3 4H8.69545L12.6279 9.11262L17.1761 4ZM16.2073 18.3754H17.7368L7.86441 5.53928H6.2232L16.2073 18.3754Z"
        fill="CurrentColor"
      ></path>
    </svg>
  </a>
);
